import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#303030',
        secondary: '#6D6D6D'
      }
    }
  }
}

export default new Vuetify(opts)
